import React, { useState, useEffect, useCallback } from 'react';
import { Button, Form, Input, Select, InputNumber, Modal, message } from 'antd';
import { getBankList, initiateTransfer, approveTransfer } from '../../services/api';

const { Option } = Select;

const ManualTransfer = () => {
  const [form] = Form.useForm();
  const [banks, setBanks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [approvalModal, setApprovalModal] = useState({ visible: false, transferId: null });
  const [otp, setOtp] = useState('');

  const fetchBanks = useCallback(async () => {
    try {
      const response = await getBankList({ payout_system: 1 });
      setBanks(response.data);
    } catch (err) {
      message.error('Failed to load source bank accounts.');
    }
  }, []);

  useEffect(() => {
    fetchBanks();
  }, [fetchBanks]);

  const handleInitiate = async (values) => {
    setLoading(true);
    try {
      const response = await initiateTransfer(values);
      if (response.data.requires_approval) {
        setApprovalModal({ visible: true, transferId: response.data.transfer_id });
        message.info('Transfer requires approval.');
      } else {
        message.success('Transfer initiated successfully.');
        form.resetFields();
      }
    } catch (err) {
      message.error(err.response?.data?.detail || 'Failed to initiate transfer.');
    } finally {
      setLoading(false);
    }
  };

  const handleApprove = async () => {
    if (!otp) {
      message.error('Please enter the approval code.');
      return;
    }
    setLoading(true);
    try {
      await approveTransfer({ transfer_id: approvalModal.transferId, otp });
      message.success('Transfer approved and executed.');
      setApprovalModal({ visible: false, transferId: null });
      setOtp('');
      form.resetFields();
    } catch (err) {
      message.error(err.response?.data?.detail || 'Failed to approve transfer.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h2>Manual Transfer</h2>
      <Form form={form} layout="vertical" onFinish={handleInitiate} style={{ maxWidth: 500 }}>
        <Form.Item name="from_account_id" label="From Account" rules={[{ required: true }]}>
          <Select placeholder="Select source account">
            {banks.map(bank => (
              <Option key={bank.id} value={bank.id}>
                {bank.account_name} ({bank.bank_login})
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item name="beneficiary_name" label="Beneficiary Name" rules={[{ required: true, message: 'Please enter beneficiary name' }]}>
          <Input placeholder="Enter beneficiary name" />
        </Form.Item>
        <Form.Item name="to_account" label="To Account Number" rules={[{ required: true, message: 'Please enter account number' }]}>
          <Input placeholder="Enter beneficiary account number" />
        </Form.Item>
        <Form.Item name="ifsc" label="IFSC Code" rules={[{ required: true, message: 'Please enter IFSC code' }]}>
          <Input placeholder="Enter IFSC code" />
        </Form.Item>
        <Form.Item name="amount" label="Amount" rules={[{ required: true }]}>
          <InputNumber style={{ width: '100%' }} min={1} />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading}>
            Initiate Transfer
          </Button>
        </Form.Item>
      </Form>

      <Modal
        title="Transfer Approval Required"
        visible={approvalModal.visible}
        onOk={handleApprove}
        onCancel={() => setApprovalModal({ visible: false, transferId: null })}
        confirmLoading={loading}
      >
        <p>Transfer ID: {approvalModal.transferId}</p>
        <Input
          placeholder="Enter OTP / Approval Code"
          value={otp}
          onChange={(e) => setOtp(e.target.value)}
        />
      </Modal>
    </div>
  );
};
export default ManualTransfer;